const BASE_URL = "https://sendit-app.com";

export function getInviteUrl(inviteCode: string) {
  return `${BASE_URL}/join/${inviteCode}`;
}

export function getInviteDisplayUrl(inviteCode: string) {
  return `sendit-app.com/join/${inviteCode}`;
}

export async function shareOrCopyInvite(inviteCode: string, toastFn: (opts: { title: string }) => void) {
  const url = getInviteUrl(inviteCode);
  if (navigator.share) {
    try {
      await navigator.share({ title: "Join my league on SEND IT", url });
      return;
    } catch {
      // User cancelled or share failed, fall through to copy
    }
  }
  navigator.clipboard.writeText(url);
  toastFn({ title: "Invite link copied!" });
}
